<template>
  <div class="field">
    <div class="control">
      <input-tag v-model="tagValues" @input="$emit('input',$event)" :add-tag-on-keys="[13,188,9]"></input-tag>
    </div>
  </div>
</template>
<script>
import { inputProps } from '@/mixins/FormInputMixin'
import InputTag from 'vue-input-tag'
export default {
  name: 'form-tag',
  mixins: [inputProps],
  components: {
    InputTag
  },
  data () {
    return { tag: '', tagValues: this.value || [] }
  },
  methods: {
    onTagsUpdated () {
      this.$emit('input', this.tagValues)
    }
  },
  computed: {},
  watch: {
    value: function (newValue, oldValue) {
      if (newValue) { this.tagValues = JSON.parse(JSON.stringify(newValue)) } else {
        this.tagValues = []
      }
    }
  }
}
</script>

<style lang="scss">
$input-background-color: transparent;
@import "~@voerro/vue-tagsinput/dist/style";
@import "~bulma/sass/utilities/_all";
@import "~bulma/sass/elements/tag";
@import "~bulma/sass/elements/form";

.badge {
  @extend .tag;
}
.tags-input {
  input {
    @extend .input !optional;
  }
}
</style>
